export function snapToMark(
  value: number,
  marks: { value: number }[],
  snap: number = 3,
) {
  let closestMark = marks.reduce(
    (prev, curr) => {
      return Math.abs(curr.value - value) < Math.abs(prev.value - value)
        ? curr
        : prev
    },
    { value: Infinity },
  )

  if (Math.abs(closestMark.value - value) <= snap) {
    return closestMark.value
  } else {
    return value
  }
}
